/* =============================================================================
 * pixels.js — advertising / measurement pixels for interview.clozo.ai
 *
 * LOADS NOTHING ON ITS OWN. consent.js calls window.__clozoPixels.init() only
 * after the visitor accepts in the consent banner, and never on a page in
 * consent.js's SENSITIVE list (sign-in / reset / verify / account / manage /
 * cancel / welcome / app sign-in / support / book unsubscribe / 404). So every
 * pixel here is opt-in and off the sensitive pages, which is what the Privacy
 * Policy and Cookie Policy promise.
 *
 * window.__clozoPixels.init()          — load the 6 base pixels + fire PageView
 * window.__clozoPixels.fire(evt, p)    — map ONE standard event onto every pixel
 *
 * analytics.js's clozo.track(name, props) calls fire() for the named funnel
 * events (checkout_start | purchase | download_click); PageView is fired once
 * inside init(). The `signup` mapping below is dormant: nothing sends it since
 * signup.html went (D18 — Start Free Trial goes straight to checkout), so the ad
 * platforms optimise on checkout_start / purchase.
 *
 * IDs are PUBLIC by design (they ship in every visitor's browser). Recorded in
 * interview/gtm/tracking-ids.md. Base tags only need the ID; LinkedIn and X
 * NAMED conversions use the in-dashboard IDs in LI_CONVERSIONS / X_EVENTS.
 * All calls are wrapped: a blocked or slow pixel must never throw into a page.
 * ============================================================================= */
(function () {
  'use strict';

  var IDS = {
    meta:    '1775755277079963',
    ga4:     'G-TJW9HH2M45',
    uet:     '97268588',
    linkedin:'10014140',
    reddit:  'a2_jo2clvdjho5q',
    x:       'rf7ih'
  };

  /* LinkedIn conversions are per-conversion IDs created in Campaign Manager
     (Manual conversions setup -> Event-specific). LinkedIn's event-specific call
     takes NO per-event value, so revenue is deliberately not attached — the
     two paid plans differ fourfold in price and one fixed "default value" would
     misreport every sale. The conversion COUNT is accurate, which is what matters for bidding. */
  var LI_CONVERSIONS = {
    purchase: 28600892,
    signup:   28600900
  };

  /* X conversion events created in X Events Manager (Website tag / single
     event). Unlike LinkedIn, X DOES accept a per-event value, so real amounts
     are sent. Its snippet also offers email_address and phone_number — we never
     send those: handing a customer's email to an ad platform would contradict
     the published Privacy Policy. */
  var X_EVENTS = {
    purchase: 'tw-rf7ih-rf7w8',
    signup:   'tw-rf7ih-rf7wc'   // X category "Lead"
  };

  var started = false;
  // Authoritative in-memory gate. A loaded pixel library cannot be unloaded, so
  // withdrawing consent has to be enforced HERE — checking only for window.fbq
  // would keep firing events after the visitor pressed Reject.
  var allowed = false;
  function el(tag, attrs) { var e = document.createElement(tag); for (var k in attrs) e[k] = attrs[k]; return e; }
  function firstScriptInsert(s) { var f = document.getElementsByTagName('script')[0]; if (f && f.parentNode) f.parentNode.insertBefore(s, f); else document.head.appendChild(s); }

  function initMeta() {
    try {
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', IDS.meta);
      window.fbq('track', 'PageView');
    } catch (e) {}
  }
  function initGA4() {
    try {
      // The shared head carries this tag inert (<script type="text/plain" data-consent="advertising" src=…gtag/js…>, so the
      // page source shows the GA4 tag while nothing loads before consent). It is replaced here by a live copy — init() runs
      // once per page, so gtag.js loads exactly once, and only after consent.
      var s = el('script', { async: true, src: 'https://www.googletagmanager.com/gtag/js?id=' + IDS.ga4 });
      var inert = document.querySelector('script[type="text/plain"][data-consent][src^="https://www.googletagmanager.com/gtag/js"]');
      if (inert && inert.parentNode) inert.parentNode.replaceChild(s, inert); else firstScriptInsert(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      // send_page_view stays default true -> GA4 records the initial page_view.
      window.gtag('config', IDS.ga4);
    } catch (e) {}
  }
  function initUET() {
    try {
      !function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:IDS.uet,enableAutoSpaTracking:true};o.q=w[u],w[u]=new UET(o),w[u].push('pageLoad')},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=='loaded'&&s!=='complete'||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)}(window,document,'script','https://bat.bing.com/bat.js','uetq');
    } catch (e) {}
  }
  function initLinkedIn() {
    try {
      window._linkedin_partner_id = IDS.linkedin;
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(IDS.linkedin);
      if (!window.lintrk) { window.lintrk = function (a, b) { window.lintrk.q.push([a, b]); }; window.lintrk.q = []; }
      var s = el('script', { type: 'text/javascript', async: true, src: 'https://snap.licdn.com/li.lms-analytics/insight.min.js' });
      firstScriptInsert(s);
    } catch (e) {}
  }
  function initReddit() {
    try {
      !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement('script');t.src='https://www.redditstatic.com/ads/pixel.js',t.async=!0;var s=d.getElementsByTagName('script')[0];s.parentNode.insertBefore(t,s)}}(window,document);
      window.rdt('init', IDS.reddit);
      window.rdt('track', 'PageVisit');
    } catch (e) {}
  }
  function initX() {
    try {
      !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments)},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
      window.twq('config', IDS.x);
    } catch (e) {}
  }

  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : undefined; }

  // Map one standard funnel event onto every pixel. Meta, GA4, Reddit and
  // Microsoft name their conversions from the base ID alone; LinkedIn and X get
  // only the conversions that have an in-dashboard ID (purchase; signup is
  // dormant), and otherwise their base tags handle retargeting.
  function fire(evt, p) {
    if (!allowed) return;
    p = p || {};
    var value = num(p.value);
    var currency = p.currency || 'USD';
    try {
      if (evt === 'signup') {
        if (window.fbq) fbq('track', 'CompleteRegistration');
        if (window.gtag) gtag('event', 'sign_up');
        if (window.uetq) window.uetq.push('event', 'signup', { event_category: 'signup', event_label: 'signup' });
        if (window.rdt) rdt('track', 'SignUp');
        if (window.lintrk) lintrk('track', { conversion_id: LI_CONVERSIONS.signup });
        if (window.twq) twq('event', X_EVENTS.signup, {});
      } else if (evt === 'checkout_start') {
        if (window.fbq) fbq('track', 'InitiateCheckout', value != null ? { value: value, currency: currency } : {});
        if (window.gtag) gtag('event', 'begin_checkout', value != null ? { value: value, currency: currency } : {});
        if (window.uetq) window.uetq.push('event', 'begin_checkout', value != null
          ? { event_category: 'begin_checkout', event_label: 'begin_checkout', revenue_value: value, currency: currency }
          : { event_category: 'begin_checkout', event_label: 'begin_checkout' });
        if (window.rdt) rdt('track', 'AddToCart');
      } else if (evt === 'purchase') {
        var money = value != null ? { value: value, currency: currency } : {};
        if (window.fbq) fbq('track', 'Purchase', value != null ? { value: value, currency: currency } : { currency: currency });
        if (window.gtag) gtag('event', 'purchase', Object.assign({ transaction_id: p.transaction_id || undefined }, money));
        // Category and label mirror the action on purpose: a Microsoft goal can
        // be configured to match on ANY of the three, and a goal that matches on
        // the wrong field simply never fires. Mirroring makes the event match
        // whichever one was chosen.
        if (window.uetq) window.uetq.push('event', 'purchase', value != null
          ? { event_category: 'purchase', event_label: 'purchase', revenue_value: value, currency: currency }
          : { event_category: 'purchase', event_label: 'purchase' });
        if (window.rdt) rdt('track', 'Purchase', value != null ? { value: value, currency: currency, transactionId: p.transaction_id } : {});
        if (window.lintrk) lintrk('track', { conversion_id: LI_CONVERSIONS.purchase });
        if (window.twq) twq('event', X_EVENTS.purchase, value != null ? { value: value, currency: currency } : {});
      } else if (evt === 'download_click') {
        if (window.fbq) fbq('trackCustom', 'Download');
        if (window.gtag) gtag('event', 'download');
        if (window.rdt) rdt('track', 'Custom', { customEventName: 'Download' });
      }
    } catch (e) { /* a pixel error must never break a page */ }
  }

  function init() {
    allowed = true;
    if (started) return;
    started = true;
    initMeta();
    initGA4();
    initUET();
    initLinkedIn();
    initReddit();
    initX();
  }

  /* Called by consent.js when the visitor withdraws consent. The libraries stay
     in memory (they cannot be unloaded), but no further event leaves the page,
     and we tell Google and Meta explicitly so their own storage stops too. */
  function stop() {
    allowed = false;
    try { if (window.fbq) window.fbq('consent', 'revoke'); } catch (e) {}
    try {
      if (window.gtag) window.gtag('consent', 'update', {
        ad_storage: 'denied', analytics_storage: 'denied',
        ad_user_data: 'denied', ad_personalization: 'denied'
      });
    } catch (e) {}
  }

  window.__clozoPixels = { init: init, fire: fire, stop: stop, loaded: function () { return started; } };
})();
